import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { COLORS } from 'modules/core/theme/colors';
import { disabledSectionMixin } from 'modules/core/theme/mixins';
import { Modal } from 'react-bootstrap';
import styled, { keyframes } from 'styled-components';

export const LoanVariablesModalHeaderWrapper = styled(Modal.Header)<{ $showSuccessSubmit: boolean }>`
  padding-top: ${({ $showSuccessSubmit }) => ($showSuccessSubmit ? '8px' : '15px')};
  padding-bottom: ${({ $showSuccessSubmit }) => ($showSuccessSubmit ? '8px' : '0')};
  ${({ $showSuccessSubmit }) => !$showSuccessSubmit && `border-bottom: none`};
`;

export const ButtonContainerBlock = styled.div`
  display: flex;
  align-items: center;
  margin: 0 15px 0 auto;
`;

export const ButtonWorksheetBlock = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 15px 0 0;

  ${({ disabled }) => disabled && disabledSectionMixin}
`;

export const ButtonUndoBlock = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 0px 0;

  ${({ disabled }) => disabled && disabledSectionMixin}
`;

export const ButtonUndoLabel = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.BLACK};
  margin-bottom: 0;
  font-weight: ${({ theme: { boldText } }) => boldText.bold};
`;

export const ButtonUndo = styled.div`
  background-image: url(${STATIC_IMAGE_URLS.icons.undoIcon});
  background-size: cover;
  background-repeat: no-repeat;
  height: 12px;
  width: 12px;
  border: none;
  cursor: pointer;
  margin: 0 2px 1px 3px;
  color: ${COLORS.BLACK};
`;

export const ButtonViewWorksheet = styled.div`
  background-image: url(${STATIC_IMAGE_URLS.icons.externalLink});
  background-size: cover;
  background-repeat: no-repeat;
  height: 14px;
  width: 14px;
  border: none;
  cursor: pointer;
  color: ${COLORS.BLACK};
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const ButtonSpinner = styled.div`
  border: 2px solid ${COLORS.GREY_2};
  border-top: 2px solid ${COLORS.BLACK};
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: ${spin} 0.6s linear infinite;
`;
